import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { useAppSelector } from '../../hooks/useAppSelector';
import { toHumanDate, transformTimeFormatLocale } from '../../utils/data';
import { useStyles } from './conversation.styles';
import { ImageBlock } from './imageBlock/ImageBlock';

const Conversation = ({ currentChat }: any): JSX.Element => {
  const classes = useStyles();

  const chatRef = useRef(null);

  useEffect(() => {
    if (chatRef.current) {
      (chatRef.current as any).scrollTop = (chatRef.current as any).scrollHeight;
    }
  }, [currentChat]);

  let prevDate: string | null = null;

  return (
    <>
      {currentChat
        ? <Box className={classes.messagesBlock} ref={chatRef}>
          <ImageBlock className={classes.imgMessageBlock} />
          {currentChat.notices.map((item: any) => {
            const isSameDate = prevDate &&
              toHumanDate(prevDate, 'd MMM yyyy') === toHumanDate(item.createdAt, 'd MMM yyyy');
            prevDate = item.createdAt;

            return (
              <Box
                key={item.id}
                className={classes.messageBlock}
              >
                {!isSameDate && (
                  <div className={classes.date}>
                    {toHumanDate(item.createdAt, 'd MMM yyyy')}
                  </div>
                )}
                <div className={classes.message}>
                  {item.content}
                </div>
                <div className={classes.time}>
                  {transformTimeFormatLocale(item.createdAt)}
                </div>
              </Box>
            );
          })}
        </Box>
        : <Box className={classes.emptyBlock}>
          <ImageBlock className={classes.imgMainBlock} />
          <Typography>
            Select the opportunity to send an update
          </Typography>
        </Box>
      }
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default React.memo(Conversation);
